import React from 'react';
import TopBar from './TopBar';
import './TermsConditionsPage.css';
import { useToast } from '../context/ToastContext';

// Terms & Conditions Page Component
export default function TermsConditionsPage() {
  const email = 'CondoEats050126@gmail.com';
  const { showSuccess } = useToast();

  const handleEmailAction = async () => {
    // Try to copy to clipboard
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(email);
        showSuccess('Email address copied to clipboard');
      }
    } catch (err) {
      // Silently fail - not critical since mailto will still work
      console.error('Failed to copy:', err);
    }
    
    // Always open mail client (regardless of copy success/failure)
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="terms-page">
      <TopBar />
      <main className="terms-main">
        <div className="terms-container">
          <h1 className="terms-title">Terms & Conditions</h1>
          
          <div className="terms-content">
            <p className="terms-effective-date">
              <strong>Effective Date: 22/1/2026</strong>
            </p>
            <p className="terms-intro">
              By accessing or using CondoEats, you agree to the following Terms & Conditions.
            </p>

            <section className="terms-section">
              <h2 className="terms-section-title">1. About CondoEats</h2>
              <p className="terms-text">
                CondoEats is a community-based marketplace that connects residents who prepare home-cooked 
                food ("Sellers") with residents who wish to purchase food ("Buyers").
              </p>
              <p className="terms-text">
                CondoEats does not prepare, inspect, store, package, or deliver food. All food transactions 
                occur directly between Buyers and CondoEats platform.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">2. Seller Terms</h2>
              <p className="terms-text">Sellers using CondoEats agree that:</p>
              <ul className="terms-list">
                <li>Food must be prepared on the same day of pickup, unless the item is dry food.</li>
                <li>Food must be prepared in a clean kitchen and strictly no pets.</li>
                <li>Expired or unsafe ingredients must not be used.</li>
                <li>All dry food sold must be unopened and must have at least one week remaining before the expiry date.</li>
                <li>Ingredients and relevant food details must be listed accurately and honestly.</li>
                <li>Food must be handed over before or at the agreed pickup time.</li>
                <li>Repeated violations or complaints may result in account suspension or removal.</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">3. Buyer Terms</h2>
              <p className="terms-text">Buyers using CondoEats agree that:</p>
              <ul className="terms-list">
                <li>They are responsible for reviewing ingredient and allergen information before ordering.</li>
                <li>They acknowledge that food is home-cooked and not commercially certified.</li>
                <li>They acknowledge that not all sellers have received the typhoid injection.</li>
                <li>They accept the inherent risks of consuming home-prepared food.</li>
                <li>Food should be consumed on the same day of pickup, unless the item is dry food.</li>
                <li>Buyers must collect food at the agreed pickup time.</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">4. Orders, Cancellations & Refunds</h2>
              <ul className="terms-list">
                <li>Order cannot be cancelled or refunded once the payment is done.</li>
                <li>Refunds can only be requested via email if the food is not delivered.</li>
                <li>Missed pickups result in no refund.</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">5. Platform Disclaimer</h2>
              <ul className="terms-list">
                <li>CondoEats acts solely as a facilitator.</li>
                <li>CondoEats does not verify food quality, safety, or ingredient accuracy.</li>
                <li>CondoEats is not liable for health reactions, food quality issues, or disputes between users.</li>
                <li>Users agree to use the platform at their own risk.</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">6. Account Suspension & Removal</h2>
              <p className="terms-text">CondoEats reserves the right to:</p>
              <ul className="terms-list">
                <li>Suspend or remove users who violate these Terms</li>
                <li>Remove listings that pose safety or community concerns</li>
                <li>Protect platform integrity and user safety</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">7. Changes to Terms</h2>
              <p className="terms-text">
                CondoEats may update these Terms at any time. Continued use of the platform indicates 
                acceptance of the updated Terms.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">8. Contact</h2>
              <p className="terms-text">
                For questions or concerns, contact:
              </p>
              <div className="terms-contact">
                <button
                  type="button"
                  className="email-action-btn"
                  onClick={handleEmailAction}
                  aria-label="Email Condo Eats"
                  title="Opens your mail client and copies the email address"
                >
                  {email}
                </button>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}